export default import.meta.ROLLUP_FILE_URL_DJZLMXEq7mxZ$5xwpjAyTw